import React, { useEffect, useState } from 'react';
import { CircleIcon, SquareIcon, TriangleIcon } from '../PerformanceLabData';
import  ArrowDown from '../..//assets/images/noun_Sort_3095077.svg';
import { getColor } from '../../assets/js/genericHelpers';
import TableExpand from '../PerformanceTableExpand';

const TableOppDiag = (props) => {
  const { title, data } = props;
  const [toggleExpand, setToggleExpand] = useState([]);
  const [maxNumberValue, setMaxNumericValue] = useState(0);

  useEffect(() => {
    let count = 0;
    let heightNumericValue = 0;
    data && data.map((eachValue) => {
      const { details } = eachValue || {};
      const { items } = details || {};
      if (items.length > 0) {
        count++;
      }
      if (eachValue.hasOwnProperty('numericValue'))
        heightNumericValue = Math.max(
          heightNumericValue,
          eachValue.numericValue,
        );
    });
    setToggleExpand(new Array(count).fill(false));
    setMaxNumericValue(heightNumericValue);
  }, [data]);

  const handleExpandToggle = (index) => {
    let newToggleExpand = [...toggleExpand];
    newToggleExpand[index] = !newToggleExpand[index];
    setToggleExpand(newToggleExpand);
  };
  return (
    <div className={`tableOppDiag`}>
      <div className={`tableOppDiagHeader`}>
        <div>{title}</div>
        <div className={`${title === 'Opportunity' ? 'd-block' : 'd-none'}`}>
          Estimated Savings
        </div>
      </div>
      {data &&
        data.map((value, index) => {
          const { details } = value || {};
          const { items } = details || {};

          if (items.length > 0 && value.score * 100 <= 89) {
            return (
              <>
                <div
                  className='d-flex flex-column tableContainer justify-content-center position-relative hoverFa'
                  onClick={() => {
                    handleExpandToggle(index);
                  }}
                >
                  <div className='d-flex align-items-center'>
                    {value.score * 100 <= 49 ? (
                      <TriangleIcon />
                    ) : value.score * 100 > 49 && value.score * 100 <= 89 ? (
                      <SquareIcon />
                    ) : (
                      <CircleIcon />
                    )}
                    <div className='tableContainerTitle '>{value.title}</div>
                  </div>
                  <div
                    className={`tableContainerTime ${
                      value.hasOwnProperty('numericValue')
                        ? 'd-block'
                        : 'd-none'
                    }`}
                  >
                    {title === 'Diagnostics'
                      ? value.displayValue
                      : (value.numericValue / 1000).toFixed(2) + ' s'}
                  </div>
                  <div
                    className={`progressBar ${
                      value.hasOwnProperty('numericValue') &&
                      title === 'Opportunity'
                        ? 'd-block'
                        : 'd-none'
                    }`}
                    style={{
                      width: (value.numericValue * 360) / maxNumberValue,
                      background: getColor(value.score),
                    }}
                  ></div>
                  <img
                    style={{ right: 3 }}
                    src={ArrowDown}
                    className='position-absolute'
                  />
                </div>
                {toggleExpand[index] && <TableExpand data={value} />}
              </>
            );
          }
        })}
    </div>
  );
};

export const PerformanceOppDiag = ({ dataOppor, dataDiag }) => {
  const [toggleState, setToggleState] = useState('Opportunity');

  const handleToggleState = () => {
    if (toggleState === 'Opportunity') {
      setToggleState('Diagnostics');
    } else {
      setToggleState('Opportunity');
    }
  };
  return (
    <>
      <div className='titlePerformanceOpp d-flex'>
        <div
          className={`pl-2 mr-3 w-50 ${
            toggleState === 'Opportunity' ? 'opDiagBorder' : ''
          }`}
          onClick={handleToggleState}
        >
          Opportunities
        </div>
        <div
          className={` w-50 ${
            toggleState === 'Diagnostics' ? 'opDiagBorder' : ''
          }`}
          onClick={handleToggleState}
        >
          Diagnostics
        </div>
      </div>
      <div className={`IngoPerformanceOpp mt-4 mb-4`}>
        {toggleState === 'Opportunity'
          ? `These suggestions can help your page load faster. They don't directly
        affect the Performance score.`
          : `More information about the performance of your application. These numbers don't directly affect the Performance score.`}
      </div>
      <TableOppDiag
        title={toggleState}
        data={toggleState === 'Opportunity' ? dataOppor : dataDiag}
      />
    </>
  );
};
